import { render, staticRenderFns } from "./ServiceOrderInfo.vue?vue&type=template&id=631159e0&scoped=true&"
import script from "./ServiceOrderInfo.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOrderInfo.vue?vue&type=style&index=0&id=631159e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631159e0",
  null
  
)

export default component.exports